import React, { Component } from 'react';

import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Image from 'react-bootstrap/Image';
import Jumbotron from 'react-bootstrap/Jumbotron';
import Row from 'react-bootstrap/Row';

class CourseHeader extends Component {
  render() {
    return (
      <Jumbotron className='course-background secondary-jumbotron-height custom-vertical-align m-0 p-0'>
        <Container fluid className='custom-vertical-align m-0 p-0'>
          <Row className='flex-md-row-reverse custom-vertical-align m-0' style={{ width: '100%' }}>
            <Col
              xs={12}
              md={6}
              className='justify-content-center header-image-container custom-vertical-align p-1 p-md-5'>
              <Container className='m-3 m-md-5 p-0'>
                <Image
                  variant='top'
                  src='/img/Fondo-Header-Courses.png'
                  alt='Fondo-Header-Courses'
                  className='image-center'
                  height='200px'
                />
              </Container>
            </Col>
            <Col xs={12} md={6} className='justify-content-center custom-vertical-align p-1 pl-md-5 pr-md-0'>
              <Container fluid className='m-3 ml-md-5 mr-md-0 pl-2 p-md-0'>
                <h1 className='text-center mb-md-0 px-3 pl-md-5'>Modalidades e-learning y presenciales</h1>
              </Container>
            </Col>
          </Row>
        </Container>
      </Jumbotron>
    );
  }
}

export default CourseHeader;
